var TransportLayerClientRequestHeader = (function () {
    function TransportLayerClientRequestHeader() {
        this.headerMembers = {
            dataset: { id_dataset: 0 },
            id_job: 0,
            flags: 0,
            resend_counter: 0,
            timeout: 6000,
            authentication_identifiers: {
                id_application: 0,
                id_user: 0
            },
            cache_key: { value: [] },
            previous_response_hash: { value: [] }
        };
        this.flags = [];
    }
    TransportLayerClientRequestHeader.prototype.getPtlMessage = function () {
        return this.headerMembers;
    };
    TransportLayerClientRequestHeader.prototype.getQuality = function () {
        var _this = this;
        var qualities = Object.keys(TransportLayerClientRequestHeader.PRICE_QUALITY);
        return qualities.find(function (quality) { return TransportLayerClientRequestHeader.PRICE_QUALITY[quality] === _this.headerMembers.dataset.id_dataset; });
    };
    TransportLayerClientRequestHeader.prototype.setQuality = function (quality) {
        this.headerMembers.dataset.id_dataset = TransportLayerClientRequestHeader.PRICE_QUALITY[quality];
    };
    TransportLayerClientRequestHeader.prototype.setIdApplication = function (idApplication, replaceValueIfSet) {
        if (replaceValueIfSet === void 0) { replaceValueIfSet = false; }
        if (this.headerMembers.authentication_identifiers.id_application === 0 ||
            replaceValueIfSet) {
            this.headerMembers.authentication_identifiers.id_application = idApplication;
        }
    };
    TransportLayerClientRequestHeader.prototype.setIdUser = function (idUser, replaceValueIfSet) {
        if (replaceValueIfSet === void 0) { replaceValueIfSet = false; }
        if (this.headerMembers.authentication_identifiers.id_user === 0 ||
            replaceValueIfSet) {
            this.headerMembers.authentication_identifiers.id_user = idUser;
        }
    };
    TransportLayerClientRequestHeader.prototype.setFlag = function (flag, enable) {
        if (enable === void 0) { enable = true; }
        var flagIndex = this.flags.indexOf(flag);
        if (enable && flagIndex === -1) {
            this.flags.push(flag);
        }
        if (!enable && flagIndex > -1) {
            this.flags.splice(flagIndex, 1);
        }
        this.headerMembers.flags = this.getFlagsValue();
    };
    TransportLayerClientRequestHeader.prototype.getFlagsValue = function () {
        return this.flags.reduce(function (value, flag) { return value + TransportLayerClientRequestHeader.FLAG_VALUE[flag]; }, 0);
    };
    TransportLayerClientRequestHeader.prototype.isFlagValueSet = function (flagValue) {
        return (this.flags.find(function (value) { return value === flagValue; }) !== undefined);
    };
    TransportLayerClientRequestHeader.prototype.setJobId = function (jobId) {
        this.headerMembers.id_job = jobId;
    };
    TransportLayerClientRequestHeader.prototype.getJobId = function () {
        return this.headerMembers.id_job;
    };
    TransportLayerClientRequestHeader.prototype.countResend = function () {
        this.headerMembers.resend_counter++;
    };
    TransportLayerClientRequestHeader.prototype.getResendCounter = function () {
        return this.headerMembers.resend_counter;
    };
    TransportLayerClientRequestHeader.prototype.setTimeout = function (timeout) {
        if (timeout > 0) {
            this.headerMembers.timeout = timeout;
            return;
        }
        throw new Error("An error has been attempted to set the timeout to \"" + timeout + "\". The timeout must be greater than 0.");
    };
    TransportLayerClientRequestHeader.prototype.getTimeout = function () {
        return this.headerMembers.timeout;
    };
    TransportLayerClientRequestHeader.getDataSet = function (priceQuality) {
        if (TransportLayerClientRequestHeader.PRICE_QUALITY.hasOwnProperty(priceQuality)) {
            return TransportLayerClientRequestHeader.PRICE_QUALITY[priceQuality];
        }
        return TransportLayerClientRequestHeader.PRICE_QUALITY.DLY;
    };
    TransportLayerClientRequestHeader.PRICE_QUALITY = {
        RLT: 129,
        DLY: 0,
        EOD: 130
    };
    TransportLayerClientRequestHeader.FLAG_VALUE = {
        add_subscription: 1,
        no_merge: 2,
        support_caching: 4,
        permission_denied_response: 8,
        internal_client: 16,
        current_state_refresh: 32,
        subscription_use_pull_permissions: 64
    };
    return TransportLayerClientRequestHeader;
}());
export { TransportLayerClientRequestHeader };
//# sourceMappingURL=TransportLayerClientRequestHeader.js.map